
import Layout from '@/views/layout/Layout';

const authCode = {
  path: '/customer',
  component: Layout,
  name: 'customerView',
  redirect: '/customer/view',
  children: [
    {
      name: 'customerIndex',
      path: '/customer/view',
      meta: {
        sign: 'customer',
        signType: 'page',
        title: '项目管理',
        isCrumb: true,
        backPage: true
      },
      redirect: '/customer/view/list',
      component: () => import('@/views/customer/index.vue'),
      children: [{
        name: 'authCodeList',
        path: '/customer/view/list',
        meta: {
          sign: 'customer',
          signType: 'page',
          title: '项目列表',
          isCrumb: true
        },
        component: () => import('@/views/customer/customerList.vue')
      }]
    }
  ]
};

export default authCode;